import { normaliseMoney } from "./normaliseMoney";

const normaliseSelectedModifier = (modifier = {}) => {
  const quantity = Number(modifier.quantity || 1);
  const amount = Math.abs(normaliseMoney(modifier.amount));
  const isDiscount = Boolean(modifier.isDiscount);

  return {
    id: modifier.id || "",
    label: modifier.label || modifier.name || "",
    amount,
    amountType: modifier.amountType || "fixed",
    quantity,
    type: modifier.type || (isDiscount ? "discount" : "charge"),
    isDiscount,
    isCustom: Boolean(modifier.isCustom),
    total: amount * quantity,
  };
};

export const calculateParaplanningCost = ({
  chargeItem,
  selectedModifiers = [],
}) => {
  const baseCost = normaliseMoney(chargeItem?.amount);
  const catalogueModifiers = chargeItem?.modifiers || [];

  const modifiers = selectedModifiers
    .map((selectedModifier) => {
      if (typeof selectedModifier === "string") {
        const catalogueModifier = catalogueModifiers.find(
          (modifier) => modifier.id === selectedModifier,
        );

        if (!catalogueModifier) return null;

        return normaliseSelectedModifier({
          ...catalogueModifier,
          quantity: 1,
          type: "charge",
          isDiscount: false,
          isCustom: false,
        });
      }

      return normaliseSelectedModifier(selectedModifier);
    })
    .filter(Boolean);

  const additionalCost = modifiers.reduce((total, modifier) => {
    return modifier.isDiscount
      ? total - normaliseMoney(modifier.total)
      : total + normaliseMoney(modifier.total);
  }, 0);

  const totalCost = baseCost + additionalCost;

  return {
    baseCost,
    additionalCost,
    totalCost,
    modifiers,
  };
};
